import { IMatrix4 } from '@inter-ikea-betrakta/viewer';
import { MathUtils, VectorConstants } from '@inter-ikea-core/core';
export class AdapterUtils {
    static modelTransformToMatrix(modelTransformComponent) {
        const rotationAngles = modelTransformComponent?.transform.rotation ?? VectorConstants.ZERO;
        const rotation = MathUtils.quaternionFromEulerDegrees(rotationAngles);
        const rotationMatrix = MathUtils.quaternionToRotationMatrix(rotation);
        const viewerRotationMatrix = IMatrix4.from_array(rotationMatrix);
        const scale = modelTransformComponent?.transform.scale ?? VectorConstants.ONE;
        const scaleMatrix = IMatrix4.Scale(scale.X, scale.Y, scale.Z);
        const translation = modelTransformComponent?.transform.position ?? VectorConstants.ZERO;
        // Adjust for millimeters.
        const translationMatrix = IMatrix4.Translation(translation.X / 1000.0, translation.Y / 1000.0, translation.Z / 1000.0);
        const combinedMatrix = IMatrix4.multiply(IMatrix4.multiply(translationMatrix, viewerRotationMatrix), scaleMatrix);
        return combinedMatrix;
    }
}
//# sourceMappingURL=AdapterUtils.js.map